/**
 * Check if the string starts with character using `indexOf`
 * @param {String} input
 * @param {Array<String>} characters
 * @returns {Boolean}
 */
const indexStartWith = (input, characters) => {
  return characters.some((string) => input.indexOf(string) === 0);
}

export default indexStartWith;